import { useEffect, useState } from 'react';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { X } from 'lucide-react';
import api from '../../../lib/api';

const SUGERIDAS = ['anticipos recibidos', 'fondos por rendir', 'devoluc'];

// Contracuenta del Recibo de Caja cuando NO son facturas: cualquier cuenta del plan contable de Alegra.
export function CuentaContableSearch({ value, onChange }) {
  const [q, setQ] = useState('');
  const [opts, setOpts] = useState([]);
  const [sugeridas, setSugeridas] = useState([]);

  useEffect(() => {
    Promise.all(SUGERIDAS.map((s) => api.get('/conciliacion-bancaria/cuentas-contables', { params: { q: s } }).then((r) => r.data.cuentas || []).catch(() => [])))
      .then((lists) => setSugeridas([...new Map(lists.flat().map((c) => [c.id, c])).values()].slice(0, 6)));
  }, []);

  useEffect(() => {
    if (value || q.trim().length < 2) { setOpts([]); return undefined; }
    const t = setTimeout(async () => {
      try {
        const r = await api.get('/conciliacion-bancaria/cuentas-contables', { params: { q: q.trim() } });
        setOpts((r.data.cuentas || []).slice(0, 25));
      } catch { setOpts([]); }
    }, 250);
    return () => clearTimeout(t);
  }, [q, value]);

  if (value) {
    return (
      <div className="flex items-center justify-between rounded-md border bg-sky-50 px-2 py-1.5 text-sm" data-testid="cuenta-seleccionada">
        <span className="truncate"><b>{value.name}</b> <span className="text-xs text-muted-foreground">({value.type})</span></span>
        <Button size="sm" variant="ghost" className="h-6 w-6 p-0" onClick={() => onChange(null)} data-testid="cuenta-quitar"><X className="h-3.5 w-3.5" /></Button>
      </div>
    );
  }
  return (
    <div className="space-y-1">
      <div className="relative">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar cuenta del plan contable…" className="text-sm" data-testid="cuenta-input" />
        {opts.length > 0 && (
          <div className="absolute z-20 mt-1 max-h-48 w-full overflow-y-auto rounded-md border bg-white shadow-md" data-testid="cuenta-opciones">
            {opts.map((o) => (
              <button key={o.id} type="button" onClick={() => { onChange(o); setQ(''); setOpts([]); }}
                className="flex w-full items-center justify-between px-2 py-1.5 text-left text-xs hover:bg-slate-50" data-testid={`cuenta-opcion-${o.id}`}>
                <span className="truncate">{o.name}</span><span className="ml-2 text-muted-foreground">{o.type}</span>
              </button>
            ))}
          </div>
        )}
      </div>
      {sugeridas.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {sugeridas.map((c) => (
            <button key={c.id} type="button" onClick={() => onChange(c)} className="rounded-full border px-2 py-0.5 text-[11px] hover:bg-slate-50" data-testid={`cuenta-sugerida-${c.id}`}>{c.name}</button>
          ))}
        </div>
      )}
    </div>
  );
}
